






















import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin, inAppAlertLogin } from '@/common/ts/common';
import { Toast, Popup } from 'vant';
import { loginInfo } from '../api';
Vue.use(Toast).use(Popup);
@Component
export default class Home extends Vue {
  isAnswer = false;
  async mounted() {
    // const data = {
    //   unionid: window.localStorage.getItem('unionid'),
    //   nickname: window.localStorage.getItem('nickname'),
    //   headImg: window.localStorage.getItem('headimgurl'),
    // };
  }
  async login() {
    const unionid = window.localStorage.getItem('unionid');
    const token = window.gettoken();
    if (!unionid && isWeiXin()) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    } else if (window.udid && (token === 'null' || !token)) {
      inAppAlertLogin();
    } else if (!window.udid && !isWeiXin()) {
      return Toast.fail('请微信或者上游新闻APP中打开');
    }
    // const unionid = window.localStorage.getItem('unionid');
    // if (!unionid && isWeiXin()) {
    //   const appId = 'wx1949ed4a473b87ed';
    //   location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
    //     location.href,
    //   )}`;
    // } else if (!isWeiXin()) {
    //   return Toast.fail('请在微信中打开');
    // }
    // const data = {
    //   unionid: window.localStorage.getItem('unionid'),
    //   nickname: window.localStorage.getItem('nickname'),
    //   headImg: window.localStorage.getItem('headimgurl'),
    // };
    // const data = {
    //   unionid: 'oGN7AjkZmK0rKbC6H4O0tsKRMpZU',
    //   nickname: '人点点',
    //   headImg:
    //     'https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eqLYXjqBLjyiaE6aBZjJDNGnTWW4nib17pSUA5FWrRacfXYLYamrLGEZibWGN6rX4hLvCdPeTqOfzjBA/132',
    // };
    let data = {};
    if (isWeiXin()) {
      data = {
        unionid: window.localStorage.getItem('unionid'),
        nickname: window.localStorage.getItem('nickname'),
        headImg: window.localStorage.getItem('headimgurl'),
      };
    } else {
      data = {};
    }
    const res: any = await loginInfo(data);

    if (res.code === 200) {
      this.$router.push(`save?id=${res.data.id}`);
    } else {
      Toast.fail(res.msg);
    }
    // else {
    //   this.isAnswer = true;
    // }
    // $router.push('save')
  }
}
